import React from "react";
import autoBind from "react-autobind";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Redirect} from "react-router-dom";
import Field from "../../components/Field";
import noty from "../../lib/noty";
import feathers from "../../feathers";
import {isStrongPassword} from "../../lib";

class AcceptInvitation extends React.Component {
  constructor(props) {
    super(props);
    this.acceptService = feathers.service("auth/accept-invite");
    this.state = {
      loaded: false,
      redirect: null,
      error: null,
      fetching: false,
      invitation: {},
      account: {},
      user: {
        email: "",
        first_name: "",
        last_name: "",
        password: ""
      },
      isNewUser: null
    };
    autoBind(this);
  }

  async componentDidMount() {
    try {
      const {invitationId} = this.props.match.params;
      let {invitation, account, isNewUser} = await this.acceptService.get(invitationId);
      this.setState({
        loaded: true,
        invitation,
        account,
        user: {...this.state.user, email: invitation.email},
        isNewUser
      });
    } catch (err) {
      noty.errors(err);
      setTimeout(() => {
        this.setState({redirect: "/login"});
      }, 3000);
    }
  }

  getPasswordHelp(password) {
    if (!password) {
      return "";
    } else {
      return isStrongPassword(password) ? "Great!" : "Please enter a stronger password.";
    }
  }

  handleChange({name, value}) {
    this.setState({user: {...this.state.user, [name]: value}});
  }

  handleDecline(event) {
    event.preventDefault();
    this.setState({fetching: true, error: false});
    const {invitationId} = this.props.match.params;
    this.acceptService
      .update(invitationId, {accept: false})
      .then(resp => {
        noty.success(resp.message);
        setTimeout(() => {
          this.setState({redirect: "/login"});
        }, 3000);
      })
      .catch(err => {
        this.setState({
          error: err.message,
          fetching: false
        });
      });
  }

  async handleAccept(event) {
    try {
      event.preventDefault();
      const {user, isNewUser} = this.state;
      let payload = {accept: true, user, isNewUser};
      this.setState({fetching: true, error: false});
      const {invitationId} = this.props.match.params;
      let {user: updatedUser} = await this.acceptService.update(invitationId, payload, {skipHooks: "redirectUnAuthed"});
      await feathers._authenticate({strategy: "local", email: updatedUser.email, password: payload.user.password});
      this.props.onSuccess("/map");
    } catch (err) {
      this.setState({error: err.message, fetching: false});
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const {account, user, isNewUser, loaded, fetching} = this.state;
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12">
              {loaded && (
                <div>
                  <Paper className="unauthed-box">
                    <h2>Congratulations!</h2>
                    <p>You have been invited to join {account.name}.</p>
                    <form onSubmit={this.handleSubmit}>
                      {isNewUser && (
                        <React.Fragment>
                          <div className="row">
                            <div className="col-xs-6">
                              <Field
                                label="First Name"
                                name="first_name"
                                value={user.first_name}
                                onChange={this.handleChange}
                                disabled={fetching}
                              />
                            </div>
                            <div className="col-xs-6">
                              <Field
                                floatingLabelText="Last Name"
                                name="last_name"
                                value={user.last_name}
                                onChange={this.handleChange}
                                disabled={fetching}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12">
                              <Field
                                disabled
                                label="Email"
                                name="email"
                                type="email"
                                value={user.email}
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12">
                              <Field
                                label="Password"
                                name="password"
                                value={user.password}
                                onChange={this.handleChange}
                                type="password"
                                disabled={fetching}
                                helpText={this.getPasswordHelp(user.password)}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                      {!isNewUser && (
                        <div className="row">
                          <div className="col-xs-12">
                            <Field
                              label="Password"
                              name="password"
                              value={user.password}
                              onChange={this.handleChange}
                              type="password"
                              disabled={fetching}
                            />
                          </div>
                        </div>
                      )}
                      <div className="row" style={{marginTop: 16}}>
                        <div className="col-xs">
                          <Button color="primary" onClick={this.handleDecline} disabled={fetching}>
                            Decline
                          </Button>
                        </div>
                        <div className="col-xs">
                          <Button
                            variant="contained"
                            color="primary"
                            style={{float: "right"}}
                            onClick={this.handleAccept}
                            disabled={fetching}
                            type="submit">
                            Accept Invitation!
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Paper>
                  <div>
                    {this.state.fetching && <LinearProgress mode="indeterminate" />}
                    {this.state.error && <div className="unauthed-error">{this.state.error}</div>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AcceptInvitation;



// WEBPACK FOOTER //
// ./src/pages/AcceptInvitation/index.jsx